<!-- <div style="width: 100%; margin-bottom: 16px;">
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Search Member By Name</mat-label>
    <input matInput type="text" [(ngModel)]="memberFilter.name">
    <button *ngIf="memberFilter.name" matSuffix mat-icon-button aria-label="Clear" (click)="memberFilter.name=''">
      <mat-icon>close</mat-icon>
    </button>
    <mat-hint align="start">
      <strong>
        <i>To search for both first and last names, use a space to separate the 2 names, otherwise this would search
          for first name only.</i>
      </strong>
    </mat-hint>
  </mat-form-field>
</div> -->
<!-- 
<mat-card [class.mat-elevation-z0]="disableShadow">
  <mat-card-content fxLayout="row wrap" fxLayoutGap="10px">
    <mat-form-field appearance="fill">
      <mat-label>Current Status</mat-label>
      <mat-select #statusFilter multiple [(value)]="memberFilter.status" placeholder="Current Status">
        <mat-option (click)="toggleAllSelection('status')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.status$ | async" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="!disablePartnersWellNessSurvey && partnerView">
      <mat-label>Partner</mat-label>
      <mat-select #partnerFilter multiple [(value)]="memberFilter.partner" placeholder="Partner">
        <mat-option (click)="toggleAllSelection('partner')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.partner$ | async" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="managerCoachView">
      <mat-label>Coach Team</mat-label>
      <mat-select #coachTeamFilter multiple [(value)]="memberFilter.coachTeam" placeholder="Coach Team">
        <mat-option (click)="toggleAllSelection('coachTeam')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.coachTeam" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="shiftTimeView">
      <mat-label>Session Time</mat-label>
      <mat-select #shiftTimeFilter multiple [(value)]="memberFilter.shiftTime" placeholder="Shift Time">
        <mat-option (click)="toggleAllSelection('shiftTime')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.shiftTime" [value]="option.value">{{option.label}}</mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="shiftDayView">
      <mat-label>Session Day</mat-label>
      <mat-select #shiftDayFilter multiple [(value)]="memberFilter.shiftDay" placeholder="Shift Day">
        <mat-option (click)="toggleAllSelection('shiftDay')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.shiftDay" [value]="option.value">{{option.label}}</mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="!disablePartnersWellNessSurvey">
      <mat-label>Wellness Survey Group</mat-label>
      <mat-select #wellnessSurveyGroupFilter multiple [(value)]="memberFilter.wellnessSurveyGroup"
        placeholder="Wellness Survey Group">
        <mat-option (click)="toggleAllSelection('wellnessSurveyGroup')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.wellnessSurveyGroup" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Race/Ethnicity</mat-label>
      <mat-select #raceAndEthnicityFilter multiple [(value)]="memberFilter.raceAndEthnicity"
        placeholder="Race/Ethnicity">
        <mat-option (click)="toggleAllSelection('raceAndEthnicity')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.raceAndEthnicity$ | async" [value]="option.value">
          {{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Gender</mat-label>
      <mat-select #genderFilter multiple [(value)]="memberFilter.gender" placeholder="Gender">
        <mat-option (click)="toggleAllSelection('gender')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.gender$ | async" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Orientation</mat-label>
      <mat-select #orientationFilter multiple [(value)]="memberFilter.orientation" placeholder="Orientation">
        <mat-option (click)="toggleAllSelection('orientation')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.orientation$ | async" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>City</mat-label>
      <mat-select #cityFilter multiple [(value)]="memberFilter.city" placeholder="City">
        <mat-option (click)="toggleAllSelection('city')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.city" [value]="option.value">{{option.label}}
        </mat-option>
        <mat-option [value]="'0'">No Data</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Age</mat-label>
      <mat-select #agesFilter multiple [(value)]="memberFilter.ages" placeholder="Age">
        <mat-option (click)="toggleAllSelection('ages')">-- ALL --</mat-option>
        <mat-option *ngFor="let option of filterOptions.ages" [value]="option.value">
          {{option.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Engagement Status</mat-label>
      <mat-select #engagementStatusFilter multiple [(value)]="memberFilter.engagementStatus"
        placeholder="ACTIVE ENGAGED">
        <mat-option *ngFor="let option of engagementStatusOptions" [value]="option.value">
          {{option.displayTitle}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="row wrap" style="justify-content: center;" fxFlex="0 1 auto" fxLayoutGap="15px"
      *ngIf="EnableDateRange">
      <mat-form-field appearance="fill">
        <mat-label>Show</mat-label>
        <mat-select [(value)]="filterOptions.show" (selectionChange)="onSelectShowFilter()">
          <mat-option value="all-time">All Time</mat-option>
          <mat-option value="custom-range">Custom Range</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="filterOptions.show === 'custom-range'">
        <mat-label>From</mat-label>
        <input matInput [max]="startMaxDate" (ngModelChange)="onDateInputChange('startDate', $event)"
          [ngModel]="filterOptions.startDate" [matDatepicker]="startDatePicker" placeholder="Choose a start date">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="filterOptions.show === 'custom-range'">
        <mat-label>To</mat-label>
        <input matInput [min]="endMinDate" (ngModelChange)="onDateInputChange('endDate', $event)"
          [ngModel]="filterOptions.endDate" [matDatepicker]="endDatePicker" placeholder="Choose an end date">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>


    <div fxFlex="1 1 auto">
      <button mat-flat-button color="primary" (click)="broadcastUpdate()">Apply Filter</button>
      <button mat-flat-button (click)="clearFilter()" color="warn">Clear Filter</button>
    </div>
  </mat-card-actions>
</mat-card> -->
 
  <button type="button"   class="d-flex align-items-center justify-content-between btn w-100 px-0 mb-0 m-0"
    (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
      <h6 class="mb-0 font-500">Member Filters</h6>  
      <div class="d-flex align-items-center gap-2">
        <p *ngIf="!isCollapsed" class="mb-0" style="color: var(--pinkPurple-700);">Hide Filters</p>
        <mat-icon *ngIf="isCollapsed" style="color: var(--pinkPurple-700);">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="!isCollapsed" style="color: var(--pinkPurple-700);">keyboard_arrow_up</mat-icon>
      </div>
    
  </button>
  <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" >
    <div class="form-control  search-bar mb-3">
      <svg width="17px" height="17px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.5 14.5L10.5 10.5M6.5 12.5C3.18629 12.5 0.5 9.81371 0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5C12.5 9.81371 9.81371 12.5 6.5 12.5Z"
          stroke="#A4A8B2" />
      </svg>
      <input type="text" placeholder="Search by name" [(ngModel)]="memberFilter.name">
    </div>
    <div class="row">
      <div class="col-lg-4 mb-3">
        <label for="">Current Status</label>
        <ng-select [items]="filterOptions.status$ | async" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Current Status" [(ngModel)]="memberFilter.status"
          (ngModelChange)="handleAdvanceSelection($event, 'status')" (clear)="handleClearSelection('status')"
          (add)="handleAddSelections($event,'status')" (remove)="handleRemoveSelection($event,'status')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.status.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Partner</label>
        <ng-select [items]="filterOptions.partner$ | async" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Partner" [(ngModel)]="memberFilter.partner"
          (ngModelChange)="handleAdvanceSelection($event, 'partner')" (clear)="handleClearSelection('partner')"
          (add)="handleAddSelections($event,'partner')" (remove)="handleRemoveSelection($event,'partner')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.partner.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Coach Team</label>
        <ng-select [items]="filterOptions.coachTeam" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Coach Team" [(ngModel)]="memberFilter.coachTeam"
          (ngModelChange)="handleAdvanceSelection($event, 'coachTeam')" (clear)="handleClearSelection('coachTeam')"
          (add)="handleAddSelections($event,'coachTeam')" (remove)="handleRemoveSelection($event,'coachTeam')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.coachTeam.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Session Time</label>
        <ng-select [items]="filterOptions.shiftTime" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Session Time" [(ngModel)]="memberFilter.shiftTime"
          (ngModelChange)="handleAdvanceSelection($event, 'shiftTime')" (clear)="handleClearSelection('shiftTime')"
          (add)="handleAddSelections($event,'shiftTime')" (remove)="handleRemoveSelection($event,'shiftTime')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.shiftTime.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Session Day</label>
        <ng-select [items]="filterOptions.shiftDay" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Session Day" [(ngModel)]="memberFilter.shiftDay"
          (ngModelChange)="handleAdvanceSelection($event, 'shiftDay')" (clear)="handleClearSelection('shiftDay')"
          (add)="handleAddSelections($event,'shiftDay')" (remove)="handleRemoveSelection($event,'shiftDay')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.shiftDay.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Wellness Survey Group</label>
        <ng-select [items]="filterOptions.wellnessSurveyGroup" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Wellness Survey Group" [(ngModel)]="memberFilter.wellnessSurveyGroup"
          (ngModelChange)="handleAdvanceSelection($event, 'wellnessSurveyGroup')"
          (clear)="handleClearSelection('wellnessSurveyGroup')"
          (add)="handleAddSelections($event,'wellnessSurveyGroup')"
          (remove)="handleRemoveSelection($event,'wellnessSurveyGroup')" [closeOnSelect]="false"
          [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.wellnessSurveyGroup.includes(item.value)"
              class="pointer-event-none" (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Race/Ethnicity</label>
        <ng-select [items]="filterOptions.raceAndEthnicity" bindLabel="label" bindValue="value"
          [multiple]="true" placeholder="Select Race/Ethnicity" [(ngModel)]="memberFilter.raceAndEthnicity"
          (ngModelChange)="handleAdvanceSelection($event, 'raceAndEthnicity')"
          (clear)="handleClearSelection('raceAndEthnicity')" (add)="handleAddSelections($event,'raceAndEthnicity')"
          (remove)="handleRemoveSelection($event,'raceAndEthnicity')" [closeOnSelect]="false"
          [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.raceAndEthnicity.includes(item.value)"
              class="pointer-event-none" (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Gender</label>
        <ng-select [items]="filterOptions.gender" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Gender" [(ngModel)]="memberFilter.gender"
          (ngModelChange)="handleAdvanceSelection($event, 'gender')" (clear)="handleClearSelection('gender')"
          (add)="handleAddSelections($event,'gender')" (remove)="handleRemoveSelection($event,'gender')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.gender.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Orientation</label>
        <ng-select [items]="filterOptions.orientation" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Orientation" [(ngModel)]="memberFilter.orientation"
          (ngModelChange)="handleAdvanceSelection($event, 'orientation')" (clear)="handleClearSelection('orientation')"
          (add)="handleAddSelections($event,'orientation')" (remove)="handleRemoveSelection($event,'orientation')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.orientation.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">City</label>
        <ng-select [items]="filterOptions.city" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select City" [(ngModel)]="memberFilter.city"
          (ngModelChange)="handleAdvanceSelection($event, 'city')" (clear)="handleClearSelection('city')"
          (add)="handleAddSelections($event,'city')" (remove)="handleRemoveSelection($event,'city')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.city.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Age</label>
        <ng-select [items]="filterOptions.ages" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Age" [(ngModel)]="memberFilter.ages"
          (ngModelChange)="handleAdvanceSelection($event, 'ages')" (clear)="handleClearSelection('ages')"
          (add)="handleAddSelections($event,'ages')" (remove)="handleRemoveSelection($event,'ages')"
          [closeOnSelect]="false" [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.ages.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-lg-4 mb-3">
        <label for="">Engagement Status</label>
        <ng-select [items]="filterOptions.engagementStatusOptions" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Engagement Status" [(ngModel)]="memberFilter.engagementStatus"
          (ngModelChange)="handleAdvanceSelection($event, 'engagementStatus')"
          (clear)="handleClearSelection('engagementStatus')" (add)="handleAddSelections($event,'engagementStatus')"
          (remove)="handleRemoveSelection($event,'engagementStatus')" [closeOnSelect]="false"
          [dropdownPosition]="'auto'" class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.engagementStatus.includes(item.value)"
              class="pointer-event-none" (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div>
      <!-- <div class="col-lg-4 mb-3">
        <label for="">Last Activity</label>
        <ng-select [items]="filterOptions.lastActivity" bindLabel="label" bindValue="value" [multiple]="true"
          placeholder="Select Last Activity" [(ngModel)]="memberFilter.lastActivity"
          (ngModelChange)="handleAdvanceSelection($event, 'lastActivity')"
          (clear)="handleClearSelection('lastActivity')" (add)="handleAddSelections($event,'lastActivity')"
          (remove)="handleRemoveSelection($event,'lastActivity')" [closeOnSelect]="false" [dropdownPosition]="'auto'"
          class="unwrap-options">
          <ng-template ng-option-tmp let-item="item" let-selected="selected">
            <input type="checkbox" [checked]="memberFilter.lastActivity.includes(item.value)" class="pointer-event-none"
              (click)="$event.stopPropagation()" />
            {{ item.label }}
          </ng-template>
        </ng-select>
      </div> -->
      <div class="col-lg-8 mb-3">
        <label for="">Date Range</label>
        <div fxLayout="row wrap" fxLayoutAlign="center center" class="gap-3">
          <div class="flex-grow-1">
            <div class="form-control custom-date-input">
              <input matInput [matDatepicker]="startDatePicker" [max]="todayDate" placeholder="MM/DD/YYYY"
                (dateChange)="handleDateRange('startDate', $event)" [(ngModel)]="memberFilter.startDate">
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </div>
          </div>
          <p class="mb-0">
            to
          </p>
          <div class="flex-grow-1">
            <div class="form-control custom-date-input">
              <input matInput [matDatepicker]="endDatePicker" [max]="todayDate" placeholder="MM/DD/YYYY"
                (dateChange)="handleDateRange('endDate', $event)" [(ngModel)]="memberFilter.endDate">
              <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </div>
          </div>
        </div>
      
      </div>
      <div class="col-lg-12 text-start gap-2">
        <button mat-flat-button class="rounded-8" color="primary" (click)="broadcastUpdate()" [disabled]="isFilterLoading">
         Apply Filters 
        </button>
        <button mat-stroked-button class="rounded-8" (click)="clearFilter()" [disabled]="isFilterLoading">Clear
          Filters</button>
      </div>
    </div>
  </div>
 